import React from 'react';
import { Route } from 'lucide-react';
import { StageStepper, StageActions } from './StageStepper';
import { InterviewsCard } from './InterviewsCard';
import { OfferCard } from './OfferCard';
import { NotesCard } from './NotesCard';
import { stageLabel } from './drawerShared';

export const RecruitmentTab = ({ candidate, canEdit, canConvert, saving, stageSaving, onStageChange, onConvert, interviews, offer, notes }) => (
  <div className="space-y-5" data-testid="tab-panel-recruitment">
    <section className="rounded-xl border border-slate-200 bg-white shadow-sm" data-testid="drawer-stage-section">
      <header className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-100 px-5 py-3">
        <h3 className="sf-heading flex items-center gap-2 text-sm font-semibold tracking-tight text-slate-900">
          <Route className="h-4 w-4 text-slate-400" /> Recruitment Stage
          <span className="ml-1 text-xs font-normal text-slate-400">· currently <span className="font-semibold text-slate-700">{stageLabel(candidate.stage)}</span></span>
        </h3>
        <StageActions stage={candidate.stage} canEdit={canEdit} saving={stageSaving} onStageChange={onStageChange} canConvert={canConvert} onConvert={onConvert} />
      </header>
      <div className="px-5 py-5"><StageStepper stage={candidate.stage} /></div>
      {candidate.stage === 'rejected' && <p className="border-t border-rose-100 bg-rose-50/60 px-5 py-2 text-xs text-rose-700" data-testid="stage-rejected-note">This candidate was rejected. Use “Change Stage” to reopen the application.</p>}
      {candidate.is_converted && <p className="border-t border-emerald-100 bg-emerald-50/60 px-5 py-2 text-xs text-emerald-700">Converted to employee {candidate.converted_employee_id} — record is locked.</p>}
    </section>

    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
      <InterviewsCard interviews={candidate.interviews || []} canEdit={canEdit} saving={saving} {...interviews} />
      <OfferCard offer={candidate.offer} canEdit={canEdit} saving={saving} {...offer} />
    </div>
    <NotesCard notes={candidate.interview_notes || []} canEdit={canEdit} saving={saving} {...notes} />
  </div>
);
